import {
    MENS_MAGAZINE_CONFIRM_COMPONENT,
    MENS_MAGAZINE_LINKAGE_ID,
    MENS_MAGAZINE_PROFILE_COMPONENT,
    MENS_MAGAZINE_SITE_UNIQ_API_PATH,
    MENS_NON_NO_ACCEPT_CALLBACK_URLS,
    MENS_NON_NO_DEFAULT_CALLBACK_URL,
    MENS_NON_NO_EMAIL_DOMAINS, MENS_NON_NO_LINKAGE_NAME, MENS_NON_NO_LINKAGE_SUB_ID, MENS_NON_NO_PATH,
    MENS_NON_NO_SERVICE_TERM_URL,
    MENS_NON_NO_IS_CALLBACK_OPTIONAL, MENS_MAGAZINE_WITHDRAW_CUSTOM_COMPONENT
} from "@/commons/linkage/sites/memsNonno";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory } from "vue-router";

// MEN'S NON-NO画面用ルート定義
const routes = createLinkageRoute(
    MENS_MAGAZINE_LINKAGE_ID,
    MENS_NON_NO_LINKAGE_NAME,
    MENS_NON_NO_PATH,
    MENS_MAGAZINE_SITE_UNIQ_API_PATH,
    MENS_NON_NO_DEFAULT_CALLBACK_URL,
    MENS_NON_NO_ACCEPT_CALLBACK_URLS,
    MENS_NON_NO_SERVICE_TERM_URL,
    MENS_NON_NO_EMAIL_DOMAINS,
    MENS_MAGAZINE_PROFILE_COMPONENT,
    MENS_MAGAZINE_CONFIRM_COMPONENT,
    {
        linkageSubId: MENS_NON_NO_LINKAGE_SUB_ID,
        isCallbackOptional: MENS_NON_NO_IS_CALLBACK_OPTIONAL,
        withDrawCustomComponent: MENS_MAGAZINE_WITHDRAW_CUSTOM_COMPONENT,
    }
);

// MEN'S NON-NO画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// MEN'S NON-NO画面用ルータ
export const mensNonnoRouter = router;
